import React from 'react'
import { Segment } from 'semantic-ui-react'

export default function LegacyAccountKey({ legacyApiKey }) {
  if (!legacyApiKey) {
    return null
  }
  return (
    <Segment secondary>
      <h4>Legacy account key</h4>
      <p>
        This is your original account key from the previous API key system with full access. Create
        a new API key to manage access for each integration. To make changes to your legacy key,
        contact support for help.
      </p>
      <code>
        <i className="!mr-1 far fa-key icon" />
        {legacyApiKey.slice(0, 20)}...
      </code>
    </Segment>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/Admin/ApiKey/LegacyAccountKey.js